<template>
  <el-select :value="value" @input="$emit('input', $event)" :filterable="filterable" @change="$emit('change', $event)" :clearable="clearable" placeholder="请选择行业">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
import { fetchIndustryList } from '@/api/runner/runner'

export default {
  name: 'IndustrySelect',
  props: {
    value: {},
    clearable: {
      default: false
    },
    filterable: {
      default: false
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
      this.$emit('change', value)
      this.$emit('update:industry', this.list.find(item => item.id === value))
    },
    fetchList () {
      fetchIndustryList()
        .then(data => {
          this.list = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    this.fetchList()
  }
}
</script>

<style scoped>

</style>
